import React, { useEffect, useState, useRef } from 'react';
import { Button, Col, Container, Row, Card, Badge  } from "react-bootstrap";
import { axiosOpen } from "../../api/axios";
import "./SubscriptionPlanList.scss";
import { useNavigate } from "react-router-dom";

const SubscriptionPlanList = () => {
  // get data via axios
  const userID = localStorage.userID && JSON.parse(localStorage.userID);
  const [userPlanID, setUserPlanID] = useState(null);
  const [pageLoader, setPageLoader] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [planList, setPlanList] = useState([]);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const navigate = useNavigate();

  const fetchPlanDetails = async () => {
    const response = await axiosOpen.get("subscription/list");
    setPlanList(response?.data.filter(subscription => subscription.subscription_status === "true"));
    setDataLoader(false);
  };

  async function getUserSubscriptionPlan() {
    const { data } = await axiosOpen.get(`subscriber/get/${userID}`);
    setUserPlanID(data?.plan?.planId || null)
  }

  const handlePurchase = (subscriptionPlanId) => {
    navigate(`/payment/${subscriptionPlanId}`, { replace: true });
  };

  useEffect(() => {
    fetchPlanDetails();
    getUserSubscriptionPlan()
  }, []);

  return (
    <div className="subscription-plans-list">
      <Container>
        <Row>
          <div className="section-title text-center pb-4">
            <h2>Choose your plan</h2>
          </div>

          {planList.length > 0 &&
            planList.map((plan) => (
              <Col key={plan.planId} md={4} className="mb-4">
                <div className="plan-card p-4">
                
                  <div>
                    <h5 className="card-title">{plan.name}</h5>
                    {
                      userPlanID === plan.planId && <Badge bg="success">Active</Badge>
                    }
                    <p className="price">
                      ${plan?.amount}
                      <span className="interval"> / {plan?.interval}</span>
                    </p>
                    <ul className="features px-4">
                      <li>{plan.description}</li>
                    </ul>
                  </div>
                  <Button
                    variant="primary"
                    className="subscribe-btn"
                    onClick={() => handlePurchase(plan?._id || null)}
                  >
                    Purchase
                  </Button>
                </div>
              </Col>
            ))}
          {
            planList.length === 0 && <h3 className='d-flex justify-content-center align-item-center'>No Plans Available</h3>
          }
        </Row>
      </Container>
    </div>
  );
};

export default SubscriptionPlanList;
